if (document.querySelector('.comp-nav-page-child')) {
  
  function checkOffset($fixedEl, $bottomEl) {
    var fixedEl = document.querySelector($fixedEl);
    var bottomEl = document.querySelector($bottomEl);
    function getRectTop(el){
      var rect = el.getBoundingClientRect();
      
      return rect.top;
    }
    
    if((getRectTop(fixedEl) + window.scrollY) + fixedEl.offsetHeight >= (getRectTop(bottomEl) + window.scrollY) - 50) {
        fixedEl.style.position = 'absolute';
        fixedEl.style.top = getRectTop(bottomEl) + window.scrollY - fixedEl.offsetHeight - 50 + 'px'; // restore when you scroll up
      } 
      if (window.scrollY + window.innerHeight <= (getRectTop(bottomEl) + window.scrollY)) {
          fixedEl.style.position = 'fixed'; // restore when you scroll up
          fixedEl.style.top = '230px'; // restore when you scroll up
      }
      
      //fixedEl.innerHTML = window.scrollY + window.innerHeight;
  }
  
  document.addEventListener("scroll", function(){
    checkOffset('.comp-nav-page-child', '.comp-relative-page-child');
    checkOffset('.comp-rs-static', '.comp-relative-page-child');
  });
}
